module.exports = __webpack_public_path__ + "img/codepen-square.acf5e8ee.svg";